<script lang="ts">
    import {dyData} from 'general/store';
    import TrustpilotLogo from 'general/icons/TrustpilotLogo.svelte';
    import {trustpilotStore} from 'general/store/trustpilot';
    import {parseBigNumber} from 'general/libs/parseBigNumber/parseBigNumber';
    import TrustpilotExcellent from 'desktop/components/trustpilotExcellent/TrustpilotExcellent.svelte';

    import s from './style.module.css';

    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';
    //TODO GUSA-15253: API Popups. Refactor trustpilot field
    const tpData = $dyData.trustpilot?.[side];
    const isExcellent = $trustpilotStore.score > 4.0;
</script>

{#if tpData}
    {#if isExcellent}
        <div class={s.desktopTrustpilot}>
            <TrustpilotLogo width={78} height={19} />
            <img width={85} height={16} alt="Trustpilot rating" src={$trustpilotStore.stars.url} />
            <span class={s.trustpilotReviewsNumber} role="presentation">
                {parseBigNumber($trustpilotStore.numberOfReviews)} Reviews
            </span>
        </div>
    {:else}
        <TrustpilotExcellent />
    {/if}
{/if}
